import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

const  PaymentStrip = ({price, discount, actualPrice}) => {
    return(
        <View style={styles.stripComponent}>
            <Text style={styles.price}>₹ {price}</Text>
            {
                discount ? 
                <Text style={styles.strikePrice}>₹ {actualPrice}</Text>
                : null
            }
        </View>
    )
}

export default PaymentStrip;
const styles = StyleSheet.create({
    stripComponent: {
        minWidth: 90,
        // paddingHorizontal: 10,
        //  height: 40,
        paddingVertical: 2,
        backgroundColor: '#c00707',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderTopLeftRadius: 15,
        borderBottomLeftRadius: 15,
        
    },
    price: {
        fontSize: 12,
        fontWeight: '700',
        color: '#fff'
    },
    strikePrice:{
        fontSize: 9,
        fontWeight: '600',
        color: '#fff',
        textDecorationLine: 'line-through',
    }
})